import React, { useEffect, cloneElement } from "react";
import * as R from "ramda";
import { connect } from "react-redux";
import { actions, getters } from "Portal/PortalWrapper/model";
import Loading from "components/Global/Loading";
import CSSModules from "react-css-modules";
import css from "./styles.scss";
import { withRouter } from "react-router";
import { Helmet } from "react-helmet";

const decorate = R.compose(
  connect(
    state => ({
      loading: getters.loading(state),
      id: getters.id(state),
      title: getters.title(state),
      backgroundImageUrl: getters.backgroundImageUrl(state),
      event: getters.event(state),
      accounts: getters.accounts(state)
    }),
    { init: actions.init }
  ),
  withRouter,
  CSSModules(css)
);

const Layout = ({
  init,
  location,
  params,
  loading,
  id,
  title,
  backgroundImageUrl,
  event,
  accounts,
  children
}) => {
  useEffect(() => {
    init({
      portalId: location.query.portalId || params.portalId
    });
  }, [init]);

  if (loading) {
    return <Loading className={css.loading} content="Loading Portal..." />;
  }

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <div styleName="container">
        {cloneElement(children, {
          portal: {
            id,
            title,
            background_image_url: backgroundImageUrl,
            event,
            accounts
          }
        })}
      </div>
    </>
  );
};

export default decorate(Layout);
// export default CSSModules(decorate(Layout), css);
